import Paragraph from "@tiptap/extension-paragraph";

export const CustomParagraph = Paragraph.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			style: {
				default: null,
				parseHTML: (element) => element.getAttribute("style"),
				renderHTML: (attributes) => {
					if (!attributes.style) return {};
					return { style: String(attributes.style) };
				},
			},
		};
	},
});
